<template>
  <create-dialog
    width="70%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @handleOpen="handleOpen"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.document_number')}: *`"
            v-model="model.document_id"
            name="common_words.document"
            v-validate="modelValidations.document_id"
            :error="getError('common_words.document', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div class="col-md-6 col-lg-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')} *`"
            v-model="model.first_name"
            name="common_words.name"
            v-validate="modelValidations.first_name"
            :error="getError('common_words.name', true)"
            placeholder=" ..."
          >
          </fg-input>
        </div>
        <div class="col-md-6 col-lg-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.surname')} *`"
            v-model="model.last_name"
            name="common_words.surname"
            v-validate="modelValidations.last_name"
            :error="getError('common_words.surname', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div class="col-md-6">
          <fg-input
            type="text"
            :label="`${$t('labor.worker_code')}: *`"
            v-model="model.code"
            name="common_words.code"
            v-validate="modelValidations.code"
            :error="getError('common_words.code', true)"
            placeholder="..."
            @click="handleClickOnCode()"
          >
          </fg-input>
        </div>
        <div class="col-md-12 col-lg-6">
          <fg-input
            type="text"
            :label="`${$t('common_words.card_id')}:`"
            v-model="model.card_id"
            placeholder="..."
          >
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" v-if="businesses.length > 1">
          <div class="form-group has-label">
            <label>{{ $t('common_words.company') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in businesses"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group has-label">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              collapse-tags
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-farm"
              size="large"
              v-model="model.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-6 col-xl-3">
          <div class="form-group has-label">
            <label>{{ $t('labor.type_of_contract') }}: *</label>
            <br />
            <el-select
              collapse-tags
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-contract"
              size="large"
              v-model="model.type_contract_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in typeContracts"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="form-group has-label">
            <label>{{ $t('common_words.position') }}: *</label>
            <br />
            <el-select
              id="prueba"
              collapse-tags
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-job"
              size="large"
              v-model="model.job_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in jobs"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-6 col-xl-3">
          <div class="form-group has-label">
            <label>{{ $t('labor.initial_contract_date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm required-start-date"
              v-model="model.contract_start_date"
              type="date"
              :picker-options="pickerOptions"
              range-separator="-"
              :disabled="model.route !== null && model.tmp_start_date !== null"
              :placeholder="`${$t('common_words.select')}...`"
              @change="updateDisabledEndDate"
            >
            </el-date-picker>
          </div>
        </div>
        <div v-if="model.route !== null" class="col-md-6 col-xl-3">
          <div class="form-group has-label">
            <label>{{ $t('labor.final_contract_date') }}: </label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm"
              v-model="model.contract_end_date"
              type="date"
              :picker-options="pickerOptionsEndDate"
              range-separator="-"
              :placeholder="`${$t('common_words.select')}...`"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('labor.bonus') }}:</label>
            <br />
            <el-select
              collapse-tags
              @change="selectAllFromSelect('model.bonus_id', bonuses)"
              clearable
              multiple
              filterable
              class="select-primary custom-width-select shadow-sm"
              size="large"
              v-model="model.bonus_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in bonuses"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, autoSelectElements } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRender from 'src/mixins/mixin-rerender';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import moment from 'moment';

export default {
  name: 'edit-or-create-worker',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['forceRerender'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinRender,
    MixinValidations,
  ],
  data() {
    return {
      businesses: [],
      disabledField: false,
      farms: [],
      jobs: [],
      typeContracts: [],
      bonuses: [],
      model: {
        first_name: null,
        last_name: null,
        document_id: null,
        code: null,
        card_id: null,
        contract_start_date: null,
        contract_end_date: null,
        business_id: null,
        farm_id: null,
        job_id: null,
        type_contract_id: null,
        route: null,
        bonus_id: [],
      },
      modelValidations: {
        first_name: { required: true },
        last_name: { required: true },
        document_id: { required: true },
        code: { required: true },
      },
      pickerOptions: {
        disabledDate(time) {
          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);

          return time.getTime() < currentDate.getTime();
        },
      },
      pickerOptionsEndDate: {},
    };
  },
  methods: {
    updateDisabledField(value) {
      this.disabledField = value;
    },
    handleOpen() {
      if (!this.model.isEdit) {
        this.model.business_id = autoSelectElements(0, this.businesses);
        this.model.farm_id = autoSelectElements(0, this.farms);
        this.model.job_id = autoSelectElements(0, this.jobs);
        this.model.type_contract_id = autoSelectElements(0, this.typeContracts);
      }
    },
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          } else if (!isset(this.model.farm_id)) {
            return this.validationInputsRequired('farm');
          } else if (!isset(this.model.type_contract_id)) {
            return this.validationInputsRequired('contract');
          } else if (!isset(this.model.job_id)) {
            return this.validationInputsRequired('job');
          } else if (
            !this.model.route &&
            !isset(this.model.contract_start_date)
          ) {
            return this.validationInputsRequired('start-date');
          } else {
            this.$emit('addEdit', this.model);
            return true;
          }
        }
      });
    },
    updateDisabledEndDate() {
      this.pickerOptionsEndDate.disabledDate = (time) => {
        const currentDate =
          this.model && this.model.contract_start_date
            ? new Date(this.model.contract_start_date)
            : new Date();
        currentDate.setHours(0, 0, 0, 0);

        return time.getTime() <= currentDate.getTime();
      };
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        tmp_start_date: editForm.contract_start_date,
        contract_start_date: editForm.contract_start_date
          ? moment(editForm.contract_start_date)
          : null,
        contract_end_date: editForm.contract_end_date
          ? moment(editForm.contract_end_date)
          : null,
        bonus_id: editForm.bonuses.map(({id}) => id),
        isEdit: true,
      };
      this.updateDisabledEndDate();
      this.errors.clear();
      sessionStorage.removeItem('editForm');
    }
  },
  created() {
    this.pickerOptionsEndDate = { ...this.pickerOptions };
    if (this.isIndex()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('works/jobs/field'),
        Axios.getMasters('works/typecontracts/field'),
        Axios.getMasters('works/bonuses/indexField'),
      ])
        .then((response) => {
          const [
            response_business,
            response_farm,
            response_job,
            response_typecontract,
            response_bonus,
          ] = response;
          this.businesses = response_business.data.data;
          this.farms = response_farm.data.data;
          this.jobs = response_job.data.data;
          this.typeContracts = response_typecontract.data.data;
          this.bonuses = this.concatAll(response_bonus.data.data);
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showMessageAccess();
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
  },
};
</script>
